import { EMBED_ROUTE_NAMES, PATH_PREFIX, PEOPLE_TEAM_EMBED_PATH_PATTERN } from '@townsquare/config/routes';
import { createGlobalRoute, createSiteRoute } from '@townsquare/router/create-route';

export const goalsDirectoryEmbedRoute = createGlobalRoute({
	exact: true,
	embed: true,
	name: EMBED_ROUTE_NAMES.goalsDirectory,
	path: `${PATH_PREFIX.EMBEDS}/goals`,
	subproduct: 'townsquare-goals',
});

export const goalEmbedRoute = createSiteRoute({
	exact: true,
	embed: true,
	name: EMBED_ROUTE_NAMES.goalEmbed,
	path: `${PATH_PREFIX.EMBEDS}/goal/:goalKey/:tabName(about|update)`,
	subproduct: 'townsquare-goals',
});

export const projectsDirectoryEmbedRoute = createGlobalRoute({
	exact: true,
	embed: true,
	name: EMBED_ROUTE_NAMES.projectsDirectory,
	path: `${PATH_PREFIX.EMBEDS}/projects`,
	subproduct: 'townsquare-projects',
});

export const projectEmbedRoute = createSiteRoute({
	exact: true,
	embed: true,
	name: EMBED_ROUTE_NAMES.projectEmbed,
	path: `${PATH_PREFIX.EMBEDS}/project/:projectKey/:tabName(about|update)`,
	subproduct: 'townsquare-projects',
});

export const labelEmbedRoute = createSiteRoute({
	exact: true,
	embed: true,
	name: EMBED_ROUTE_NAMES.label,
	path: `${PATH_PREFIX.EMBEDS}/label/:uuid?`,
	subproduct: 'townsquare-labels',
});

export const createKudosEmbedRouteOld = createGlobalRoute({
	embed: true,
	name: EMBED_ROUTE_NAMES.createKudosOld,
	path: '/give-kudos',
	subproduct: 'townsquare-kudos',
	query: ['type?', 'recipientId?', 'unsavedMessage?'],
});

export const createKudosEmbedRoute = createSiteRoute({
	embed: true,
	name: EMBED_ROUTE_NAMES.createKudos,
	path: `/kudos/give`,
	subproduct: 'townsquare-kudos',
	query: ['type?', 'recipientId?', 'unsavedMessage?'],
});

export const agentEmbedRoute = createGlobalRoute({
	embed: true,
	name: EMBED_ROUTE_NAMES.agentEmbed,
	path: '/people/agent/:agentId/embed',
	subproduct: 'townsquare-agents',
});

export const teamEmbedRoute = createGlobalRoute({
	exact: true,
	embed: true,
	name: EMBED_ROUTE_NAMES.teamEmbed,
	path: PEOPLE_TEAM_EMBED_PATH_PATTERN,
	subproduct: 'townsquare-teams',
});
